var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilterIcon = function SvgFilterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.323117 4.19735C-0.427543 3.31978 0.216531 2 1.34506 2H17.3264C18.4549 2 19.099 3.31978 18.3483 4.19735L18.3473 4.19855L12.0024 11.5805V14.6667C12.0024 14.8896 11.891 15.0977 11.7055 15.2214L7.70553 17.888C7.50096 18.0244 7.23793 18.0371 7.02116 17.9211C6.80438 17.8051 6.66906 17.5792 6.66906 17.3333V11.5805L0.323117 4.19735ZM1.3389 3.33362L7.8413 10.8988C7.94524 11.0197 8.00239 11.1739 8.00239 11.3333V16.0877L10.6691 14.3099V11.3333C10.6691 11.1739 10.7262 11.0197 10.8302 10.8988L17.3326 3.33362C17.3311 3.33347 17.3291 3.33333 17.3264 3.33333H1.34506C1.3424 3.33333 1.34037 3.33347 1.3389 3.33362Z",
    fill: "#2555EF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-icon.1cee8c63.svg";
export { ForwardRef as ReactComponent };